import { Alert, Button, Card, Space, Typography } from "antd";
import { Link, useLocation } from "react-router";

const { Title, Paragraph } = Typography;

function reasonContent(reason: string | null): {
  type: "error" | "warning" | "info";
  title: string;
  message: string;
} {
  switch (reason) {
    case "expired":
      return {
        type: "warning",
        title: "Invitation expired",
        message: "This invitation link has expired. Ask your administrator to resend the invitation.",
      };
    case "accepted":
      return {
        type: "info",
        title: "Invitation already used",
        message: "This invitation was already accepted. You can log in with your account.",
      };
    default:
      return {
        type: "error",
        title: "Invalid invitation",
        message: "This invitation link is invalid. Ask your administrator to send a new invitation.",
      };
  }
}

export const InvitationStatus = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const reason = params.get("reason");
  const content = reasonContent(reason);
  const showSignup = reason !== "accepted";

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 16 }}>
      <Card style={{ width: "100%", maxWidth: 460 }}>
        <Space direction="vertical" size={16} style={{ width: "100%" }}>
          <Title level={4} style={{ marginTop: 0, marginBottom: 0 }}>{content.title}</Title>
          <Alert type={content.type} showIcon message={content.message} />
          <Paragraph style={{ marginBottom: 0 }}>
            If you need help, contact your system administrator.
          </Paragraph>
          <Space direction="vertical" size={8} style={{ width: "100%" }}>
            <Button type="primary" block>
              <Link to="/login">Go to login</Link>
            </Button>
            {showSignup ? (
              <Button block>
                <Link to="/register">Go to signup</Link>
              </Button>
            ) : null}
          </Space>
        </Space>
      </Card>
    </div>
  );
};
